module.exports = __webpack_public_path__ + "media/educators/NSPA_Member-of-Logo_Teal-73503f79.png";